export const RECORDING_STATES = ["submitted", "scheduled", "recording", "processing", "completed", "cancelled", "error"] as const;

export const PrivacyOptions = [
  {value: 'public', displayValue: 'schedule.privacy.public'},
  {value: 'unlisted', displayValue: 'schedule.privacy.unlisted'},
  {value: 'private', displayValue: 'schedule.privacy.private'},
]

// Design-system state badges ("Option C"). Templates build the class as
// `badge badge-pill badge-{value}`; the styles live in
// assets/css/sass/themes/_boothpilot-overrides.scss.
//
// These replaced Bootstrap contextual names (light/info/danger/...), which
// were not design-system colors and rendered "submitted" and "cancelled"
// identically, since both mapped to "light".
export const RECORDING_STATE_COLORS = {
  "submitted": "state-submitted",
  "scheduled": "state-scheduled",
  "recording": "state-recording",
  "processing": "state-processing",
  "completed": "state-completed",
  "cancelled": "state-cancelled",
  "error": "state-error"
}